import config from "../../config";
import { css } from "emotion";
import Image from "../Image";
import Slider from "../Slider";
import Button from "../Button";
import Share from "../Share";

const maxDisplayItems = 4;
const styles = {
  mobile: css`
    display: none;
    @media (max-width: 850px) {
      display: block;
    }
  `,

  desktop: css`
    display: block;
    @media (max-width: 850px) {
      display: none;
    }
  `,

  wrapper: css`
    width: 100%;
    padding: 72px 80px;
    text-align: left;
    background: #f9f9fa;
    display: flex;
    @media (max-width: 850px) {
      padding: 40px 0px 40px 12px;
      display: block;
    }
  `,
  title: css`
    font-weight: 600;
    margin-left: 10px;
    margin-bottom: 24px !important;
    color: #323232;
    font-size: 18px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.42px;
  `,
  container: css`
    max-width: 1062px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  `,
  card: css`
    position: relative;
    border-radius: 4px;
    display: flex;
    margin-bottom: 24px;
    margin-right: 8px;
    margin-left: 8px;
    float: left;
    width: 248px;
    text-align: left;
    max-width: 330px;
    box-shadow: 0 1px 8px 1px rgba(32, 7, 64, 0.13);
    background-color: #ffffff;
    height: 332px;
    min-height: 332px;
    max-height: 332px;
    overflow: hidden;
    @media (max-width: 850px) {
      float: none;
      display: inline-block;
    }
    :hover {
      boxshadow: 0 1px 8px 3px rgba(32, 7, 64, 0.13);
    }
  `,
  eventButton: css`
    text-algin: left;
    text-decoration: none !important;
    color: #323232;
    width: 100%;
  `,
  description: css`
    width: 224px;
    margin-left: 12px;
    margin-right: 12px;
  `,
  img: css`
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    width: 248px;
    height: 124px;
  `,
  dateStyle: css`
    margin-top: 10px;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis,
    white-space: nowrap;
    width: 224px;
    height: 19px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.33px;
    color: #6621c0;
  `,
  titleAddressWrapper: css`
    @media (max-width: 850px) {
      position: absolute;
    }
  `,

  cardTitle: css`
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 600;
    color: #323232;
    white-space: normal;
    max-height: 76px;
    overflow: hidden;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.42px;
  `,
  contents: css`
    margin-bottom: 8px;
    color: #323232;
    font-size: 14px;
    width: 224px;
    height: 19px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: -0.33px;
  `,
  priceContainer: css`
    borderbottomleftradius: 4px;
    borderbottomrightradius: 4px;
    height: 30px;
    margin-bottom: 12px;
    padding-left: 12px;
    padding-right: 12px;
    position: absolute;
    bottom: 0;
    width: 100%;
    background: ;
  `,
  priceText: css`
    background-color: #f9f9fa;
    font-color: #323232;
    font-size: 14px;
    font-weight: 600;
    width: 78px;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    height: 30px;
    display: flex;
    float: left;
    overflow: hidden;
  `,
  shareButton: css`
    overflow: hidden;
    float: right;
  `
};

const EventCard = props => {
  const { eventUrl, imageUrl, ticketsPriceStr, item } = props;

  var re = /\B(?=[A-Z])|\s*\d{4}\b/g;
  var dateWithoutYear = item.dates[0].display.combined.replace(re, function(
    match
  ) {
    return match ? "" : " ";
  });

  return (
    <div className={styles.card} key={item._id}>
      <a href={eventUrl}>
        <Image className={styles.img} src={imageUrl} alt={`${item.name}`} />
        <div className={styles.description}>
          <p className={styles.dateStyle}>{dateWithoutYear}</p>
          <div className={styles.titleAddressWrapper}>
            <p className={styles.cardTitle}>{item.name}</p>
            <p className={styles.contents}>{item.location.address}</p>
          </div>
        </div>
      </a>
      <div className={styles.priceContainer}>
        {ticketsPriceStr !== "FREE" ? (
          <div />
        ) : (
          <div className={styles.priceText}>Free</div>
        )}
        <div className={styles.shareButton}>
          <Share eventLink={eventUrl} />
        </div>
      </div>
    </div>
  );
};

const EventCardList = props => {
  const { moreEvents } = props;

  return (
    <div>
      {moreEvents.map((item, index) => {
        if (index < maxDisplayItems) {
          const eventUrl = `${config("TICKETING_URL")}/${item.slug}`;
          const useOldBannerStyle =
            !item.bannerImage && item.featureImage ? true : false;

          let imageHandleOld = item.socialImage
            ? item.socialImage.url
            : item.featureImage
            ? item.featureImage.url
            : "VbieTVjAQvq5BTkE9vIi";

          let imageHandleNew = item.bannerImage
            ? item.bannerImage.url
            : "VbieTVjAQvq5BTkE9vIi";

          const imageUrl = `https://process.filestackapi.com/resize=h:165,w:330,fit:crop/${
            useOldBannerStyle ? imageHandleOld : imageHandleNew
          }`;
          const ticketsPriceStr = item.settings.ticketPriceRangeDisplay
            ? item.ticketsPriceStr
            : "";
          return (
            <EventCard
              eventUrl={eventUrl}
              imageUrl={imageUrl}
              ticketsPriceStr={ticketsPriceStr}
              item={item}
            />
          );
        }
      })}
    </div>
  );
};

const MoreEvents = props => {
  const { event, title = "More events from this organiser" } = props;
  let moreEvents = event && event.moreEvents ? event.moreEvents : [];

  if (moreEvents.length < 1) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.mobile}>
          <Slider>
            <EventCardList moreEvents={moreEvents} />
          </Slider>
        </div>
        <div className={styles.desktop}>
          <EventCardList moreEvents={moreEvents} />
        </div>
        <div style={{ clear: "both" }} />
        {moreEvents.length >= maxDisplayItems && (
          <div
            style={{ marginLeft: 10, marginTop: 12, width: 140, height: 40 }}
          >
            <Button
              type="secondary"
              aria-label="See more button"
              aria-hidden={true}
              tabIndex={-1}
              link={`${config("TICKETING_URL")}/organisers/${
                event.organiserId
              }`}
            >
              See more
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MoreEvents;
